import { useState } from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../i18n/LanguageContext";
import { toast } from "sonner";

export const Footer = () => {
  const { t } = useLanguage();
  const [email, setEmail] = useState("");

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  const subscribe = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setEmail("");
    toast.success(t.footer.subscribed);
  };

  const navItems = [
    { id: "programs", label: t.nav.programs },
    { id: "projects", label: t.nav.projects },
    { id: "careers", label: t.nav.careers },
    { id: "manifesto", label: t.nav.manifesto },
    { id: "community", label: t.nav.community },
  ];

  return (
    <footer className="bg-[#163832] text-[#FDFCF7] pt-20 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }} className="mb-16">
          <div className="font-display font-bold tracking-tight leading-[0.95] text-5xl sm:text-7xl lg:text-8xl text-[#FDFCF7]" data-testid="footer-big-type">
            {t.footer.big1}
            <br />
            <span className="text-[#C85A17]">{t.footer.big2}</span>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 border-t border-[#FDFCF7]/10 pt-10">
          <div>
            <div className="text-xs font-mono uppercase tracking-[0.22em] text-amber-400 mb-4">Maple Future Institution</div>
            <p className="text-sm text-[#FDFCF7]/60 leading-relaxed">{t.footer.campuses}</p>
            <p className="text-xs text-[#FDFCF7]/40 mt-3">{t.footer.accreditation}</p>
          </div>
          <div>
            <div className="text-xs font-mono uppercase tracking-[0.22em] text-amber-400 mb-4">{t.footer.nav}</div>
            <div className="flex flex-col gap-2.5">
              {navItems.map((n) => (
                <button key={n.id} data-testid={`footer-link-${n.id}`} onClick={() => scrollTo(n.id)}
                  className="text-left text-sm text-[#FDFCF7]/70 hover:text-[#C85A17] transition-colors duration-150 w-fit">
                  {n.label}
                </button>
              ))}
            </div>
          </div>
          <div>
            <div className="text-xs font-mono uppercase tracking-[0.22em] text-amber-400 mb-4">{t.footer.contact}</div>
            <p className="text-sm text-[#FDFCF7]/60 mb-4">{t.footer.newsletter}</p>
            <form onSubmit={subscribe} className="flex gap-2">
              <input data-testid="footer-newsletter-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                className="flex-1 text-sm bg-[#FDFCF7]/5 border border-[#FDFCF7]/15 rounded-full px-4 py-2.5 outline-none focus:border-[#C85A17] transition-colors placeholder:text-[#FDFCF7]/30" />
              <button data-testid="footer-newsletter-subscribe-button" type="submit"
                className="bg-[#C85A17] text-[#FDFCF7] text-sm font-semibold rounded-full px-5 py-2.5 hover:bg-[#a84a12] transition-colors duration-200">
                {t.footer.subscribe}
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-[#FDFCF7]/10 mt-10 pt-6 text-xs text-[#FDFCF7]/40 flex flex-col sm:flex-row justify-between gap-2">
          <span>{t.footer.rights}</span>
          <span className="font-mono tracking-widest">EST. 2026 · TORONTO</span>
        </div>
      </div>
    </footer>
  );
};
